import * as React from "react";
import "./hamburger.scss";

interface IHamburger {
  readonly handle: any;
  readonly isOpen: boolean;
}

class Hamburger extends React.Component<IHamburger, any> {
  constructor(props: IHamburger, context: any) {
    super(props, context);
  }

  public render() {
    return (
      <div
        className={`hamburger ${this.props.isOpen ? "hamburger--open" : ""}`}
        onClick={this.props.handle}
      >
        <div className="bar1" />
        <div className="bar2" />
        <div className="bar3" />
      </div>
    );
  }
}

export default Hamburger;



// WEBPACK FOOTER //
// ./src/components/header/components/hamburger/hamburger.tsx